import React, { useEffect, useRef } from 'react'

const AutoTextArea = (props: any) => {
  const textAreaRef = useRef<HTMLTextAreaElement>(null)

  useEffect(() => {
    textAreaRef.current.style.overflow = 'hidden'
    textAreaRef.current.style.resize = 'none'
    textAreaRef.current.style.height = '30px'
    textAreaRef.current.style.height = textAreaRef.current.scrollHeight + 'px'
  }, [props])

  const onChangeHandler = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    props.onChangeHandler(event)
  }

  return <textarea {...props} ref={textAreaRef} onChange={onChangeHandler} />
}

export default AutoTextArea
